export default __webpack_public_path__ + "static/media/gallery-wip-emitter_00.b3be124e.jpg";